var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.results !== null)?_c('span',{staticClass:"ml-2"},[(!_vm.results)?_c('span',[_c('i',{staticClass:"fa fa-check text-success mr-1"}),_c('small',{staticClass:"text-success"},[_vm._v("Valid")])]):_c('span',[_c('i',{staticClass:"fa fa-times text-danger mr-1"}),_c('small',{staticClass:"text-danger"},[_vm._v("Invalid (duplicate)")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }